import moment from 'moment';
import React from 'react';
import ModernDatepicker from 'react-modern-datepicker';
import { I18n } from 'react-redux-i18n';

import FIELDS from '../../data/fields';
import ModalComponent from '../modal';
import TablePagination from './pagination';

class Table extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      searchTimeout: null,
      search: '',
      orderBy: 'DESC',
      columnSort: '',
      initialDate: '',
      finalDate: '',
      titleModal: '',
      titleModalBody: '',
      showModal: '',
    };
  }

  handleDate = (date, type) => {
    this.setState({ [type]: moment(date, 'DD-MM-YYYY') });
  }

  validateDate = (reset = false) => {
    const { initialDate, finalDate } = this.state;

    if (reset) {
      this.setState({ initialDate: '', finalDate: '' });
      this.props.filterByDate('', '');
    } else if (!initialDate || !finalDate) {
      this.setState({
        showModal: true,
        titleModal: I18n.t('Error'),
        titleModalBody: I18n.t('dateFieldsNotReported'),
      });
    } else if (moment(finalDate).isBefore(initialDate, 'day')) {
      this.setState({
        showModal: true,
        titleModal: I18n.t('Error'),
        titleModalBody: I18n.t('startDateAndGreater'),
      });
    } else {
      this.props.filterByDate(moment(initialDate).format(), moment(finalDate).format());
    }
  }

  setPage = async (page) => {
    await this.searchItems(this.state.search, page);
  }

  setSearch = async (e) => {
    const searchText = e.target.value;
    if (this.state.searchTimeout) clearTimeout(this.state.searchTimeout);
    const searchTimeout = setTimeout(async () => this.searchItems(searchText, 1), 400);
    this.setState({ searchTimeout, search: searchText });
  }

  searchItems = async (search, page) => {
    if (this.props.searchItems) {
      await this.props.searchItems(search, page);
    }
  }

  setSort = async (element) => {
    const column = element.key;
    const notDisplay = !element.notDisplay;

    if (column !== 'action' && column !== 'runtimeAction' && column !== 'invoices' && column !== 'providerReturn' && column !== 'cancel' && notDisplay) {
      let { orderBy, columnSort } = this.state;

      if (columnSort === column) {
        if (orderBy === 'DESC') {
          orderBy = 'ASC';
        } else {
          orderBy = 'DESC';
        }
      } else {
        orderBy = 'DESC';
        columnSort = column;
      }

      this.setState({ orderBy, columnSort });

      await this.sortTable(columnSort, orderBy);
    }
  }

  sortTable = async (column, orderBy) => {
    if (this.props.sortTable) {
      await this.props.sortTable(column, orderBy);
    }
  }

  render() {
    const {
      title, buttons, extras, alternativeExtras = false,
      className, header = [], lines = [], lineClassNames = {}, noHeader,
      page = 1, perPage = 20, count = 0,
      showItemsCount = false, clientData = null,
      subTableKey = '', parentRecordName, minDate, maxDate,
      placeholderSearch = I18n.t('search'),
    } = this.props;
    const {
      search = '', titleModal, titleModalBody, showModal,
    } = this.state;

    const getTdClass = (lineIndex, col) => {
      let classTdName;
      if (col.tdClassName) classTdName = col.tdClassName;

      if (lineClassNames[col.key] && lineClassNames[col.key][lineIndex]
        && lineClassNames[col.key][lineIndex].className) {
        classTdName += ` ${lineClassNames[col.key][lineIndex].className}`;
      }

      return classTdName || 'align-middle';
    };

    const setArrow = (column) => {
      let classArrow = '';
      const { orderBy, columnSort } = this.state;

      if (this.props.sortTable) {
        classArrow = 'sort-direction';
        if (columnSort === column) {
          classArrow += orderBy === 'ASC' ? ' asc' : ' desc';
        } else {
          classArrow = '';
        }
      }

      return classArrow;
    };

    return (
      <div className="main-table main-table-overflow">
        <div className="main-header-table">
          <h2 className="header-form-client">
            {title}
          </h2>

          {clientData && (
            <div className="container-client-data">
              <span className="client-data-table">
                {clientData.clientId}
                {' - '}
                {clientData.sphereClient.name}
                {' - '}
                {clientData.nickname}
              </span>
            </div>
          )}

          {parentRecordName && (
            <div className="container-client-data">
              <span className="client-data-table">
                {parentRecordName}
              </span>
            </div>
          )}

          {(alternativeExtras === false) && (
            <React.Fragment>
              {buttons}
              {this.props.searchItems && (
                <input
                  className="float-right search-width-35p form-control"
                  type="text"
                  placeholder={placeholderSearch}
                  maxLength={FIELDS.default}
                  value={search}
                  onChange={this.setSearch}
                />
              )}
            </React.Fragment>
          )}

          {(alternativeExtras === true) && (
            <div className="row" style={{ alignItems: 'center' }}>
              <div className="col-md-6">
                {buttons}
              </div>

              <div className="col-md-3">
                {extras}
              </div>

              <div className="col-md-3">
                {this.props.searchItems && (
                  <input
                    className="float-right form-control"
                    type="text"
                    placeholder={placeholderSearch}
                    maxLength={FIELDS.default}
                    value={search}
                    onChange={this.setSearch}
                  />
                )}
              </div>
            </div>
          )}
        </div>

        {(alternativeExtras === false) && (
          <div className="row d-flex justify-content-end mr-2">
            {extras}
          </div>
        )}

        {(this.props.filterByDate) && (
          <React.Fragment>
            <br />
            <div className="row d-flex justify-content-end ">
              <div className="col-1-5">
                <ModernDatepicker
                  date={this.state.initialDate}
                  format="DD-MM-YYYY"
                  showBorder
                  onChange={date => this.handleDate(date, 'initialDate')}
                  placeholder={I18n.t('initDate')}
                  className="form-control"
                  minDate={minDate}
                  maxDate={maxDate}
                />
              </div>
              <div className="col-1-5">
                <ModernDatepicker
                  date={this.state.finalDate}
                  format="DD-MM-YYYY"
                  showBorder
                  onChange={date => this.handleDate(date, 'finalDate')}
                  placeholder={I18n.t('finDate')}
                  className="form-control"
                  minDate={minDate}
                  maxDate={maxDate}
                />
              </div>
              <button
                onClick={() => this.validateDate(false)}
                type="button"
                className="btn btn-secondary mr-2"
              >
                {I18n.t('filter')}
              </button>
              <button
                onClick={() => this.validateDate(true)}
                type="button"
                className="btn btn-secondary mr-1"
              >
                {I18n.t('clean')}
              </button>
            </div>
            <br />
          </React.Fragment>
        )}

        <table className={`table table-striped ${className}`}>
          {!noHeader && (
            <thead>
              <tr>
                {header.map(h => !h.hidden && (
                  <th key={h.key} className={h.className} colSpan={h.colspan} onClick={() => this.setSort(h)}>
                    {h.value}
                    <span className={setArrow(h.key)} />
                  </th>
                ))}
              </tr>
            </thead>
          )}

          <tbody>
            {lines.map((line, index) => (
              <React.Fragment key={line.key}>
                <tr className={line.className}>
                  {header.map(h => (
                    <td key={h.key} className={getTdClass(index, h)}>
                      {h.key === 'runtimeAction' && line[h.key] && (
                        this.props.runtimeAction(line.key, line)
                      )}
                      {!(h.key === 'runtimeAction') && (line[h.key])}
                    </td>
                  ))}
                </tr>
                {line.key === subTableKey && (
                  <tr>
                    <td colSpan={header.length} style={{ border: 'solid #d9e0e7 2px', padding: '5px' }}>
                      {this.props.subTable()}
                    </td>
                  </tr>
                )}
              </React.Fragment>
            ))}
          </tbody>
        </table>

        <TablePagination
          setPage={this.setPage}
          numberOfItems={count}
          numberOfItemsForPage={perPage}
          activePage={page}
          showItemsCount={showItemsCount}
        />

        {lines.length === 0 && <p>Nenhum item encontrado.</p>}

        <ModalComponent
          title={titleModal}
          body={titleModalBody}
          visible={showModal}
          closeModal={() => this.setState({ showModal: false })}
          titleOkButtoon={I18n.t('ok')}
          size={{ width: '350px', height: '200px' }}
          showButtons
          confirmModal={() => { this.setState({ showModal: false }); }}
        />
      </div>
    );
  }
}

export default Table;
